import { useEffect, useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { isAuthenticated } from '../../services/Auth/AuthService';
import { fetchNotifications } from 'store/modules/NotificationsActions';

const RouteChangeTrackerNotifications = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const currentPage = 0;
  const debounceTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleRouteChange = useCallback(() => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      (async () => {
        if (await isAuthenticated()) {
          dispatch(fetchNotifications(currentPage));
        }
      })();
    }, 800);
  }, [dispatch, currentPage]);

  useEffect(() => {
    const unlisten = history.listen(handleRouteChange);
    return () => {
      unlisten();
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, [history, handleRouteChange]);

  return null;
};

export default RouteChangeTrackerNotifications;